import axios from 'axios';
import { ENDPOINTS } from './_config';

export async function validateRecruiterEmail(emailAddress, setState) {
    const encodedEmail = encodeURIComponent(emailAddress);
    const url = `${ENDPOINTS.RECRUITERS.RECRUITER_EMAIL_VALIDATION}?emailAddress=${encodedEmail}`;

    try {
        const response = await axios.get(url);
        setState(response.data.data)
        return response.data;
    } catch (error) {
        if(error.status == '400'){
            setState(error.response.data.message)
        }
        return error;
    }
}